import { render } from "./AIinspection.vue?vue&type=template&id=3995d1df&scoped=true"
import script from "./AIinspection.vue?vue&type=script&lang=js"
export * from "./AIinspection.vue?vue&type=script&lang=js"

import "./AIinspection.vue?vue&type=style&index=0&id=3995d1df&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3995d1df"

export default script